import { createMedia } from "@artsy/fresnel";
import React, { Component } from "react";
import AliceCarousel from "react-alice-carousel";
import { connect } from "react-redux";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Image,
  Segment,
} from "semantic-ui-react";
import NextLevel from "../components/NextLevel";
import { fetchAnalysis } from "../redux/actions/actions";

const { MediaContextProvider, Media } = createMedia({
  // breakpoints values can be either strings or integers
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});
export class AIVision extends Component {
  componentDidMount() {
    this.props.dispatch(fetchAnalysis());
  }
  render() {
    return (
      <>
        <div style={{ backgroundColor: "#f1f1f1" }}>
          <Container textAlign="center" style={{ paddingTop: "3em" }}>
            <Header as="h3">MUSE API 03</Header>
            <Header style={{ fontSize: "48px" }}>
              MUSE AI Vision API
            </Header>
            {/* <p>지금 MUSE Vision API를 체험해 보세요</p> */}
          </Container>

          <Container style={{ padding: "2em" }}>
            <Segment raised style={{ paddingTop: 40 }} textAlign="center">
              {/* <Visualization /> */}

              <Header>Application on Palm Oil Fruit Ripeness Detection</Header>
              <AliceCarousel autoPlay autoPlayInterval="3000">
                <Image src="/palm1.png" />
                <Image src="/palm3.png" />
                <Image src="/palm4.png" />
                <Image src="/palm5.png" />
              </AliceCarousel>
              <Divider hidden />

              <Button
                color="orange"
                href="https://www.youtube.com/watch?v=I0WporBtMn8"
              >
                Watch Video
              </Button>
              <Divider />
              <Header>
                Application on Automated Indoor Plant Detection / Identification
              </Header>
              <AliceCarousel autoPlay autoPlayInterval="3000">
                <Image src="/indoor_plant_detection.png" />
                <Image src="/indoor_plant_analysis.png" />
              </AliceCarousel>
              <Divider hidden />

              <Button
                href="https://www.youtube.com/watch?v=GpN6yfDqhAY"
                color="orange"
              >
                Watch Video
              </Button>
            </Segment>
          </Container>
        </div>
        <Divider hidden />
        <Divider hidden />

        <Header textAlign="center" style={{ fontSize: "48px" }}>
          Muse AI Vision API
        </Header>
        <Divider hidden />
        <Divider hidden />

        <div style={{ padding: 50 }}>
          <Grid container stackable verticalAlign="top">
            <Grid.Row columns={3}>
              <Grid.Column>
                <Image width="90px" src="/Framevision1.png" />
                <Header style={{fontSize:"28px"}}>Facial Expression Analysis</Header>
                <p style={{fontSize:"24px"}}>
                  Detects and matches different users and their facial expressions{" "}
                </p>
              </Grid.Column>
              <Grid.Column>
                <Image width="90px" src="/Framevision2.png" />
                <Header style={{fontSize:"28px"}}>Object Detection and Analysis</Header>
                <p style={{fontSize:"24px"}}>
                  Detects the presence of objects and analyzes their type
                </p>
              </Grid.Column>
              <Grid.Column>
                <Image width="90px" src="/Framevision3.png" />
                <Header style={{fontSize:"28px"}}>Image Analysis</Header>
                <p style={{fontSize:"24px"}}>
                  Detects and describes the overall scene in which the AI finds itself
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider hidden />

          <Grid container stackable verticalAlign="top">
            <Grid.Row columns={3}>
              <Grid.Column>
                <Image width="90px" src="/Framevision4.png" />
                <Header style={{fontSize:"28px"}}>Human Detection</Header>
                <p style={{fontSize:"24px"}}>
                  Detects whether the subject is human
                </p>
              </Grid.Column>
              <Grid.Column>
                <Image width="90px" src="/Framevision5.png" />
                <Header style={{fontSize:"28px"}}>Plant Detection</Header>
                <p style={{fontSize:"24px"}}>
                  Detects whether the subject is a plant or fruit
                </p>
              </Grid.Column>
              <Grid.Column>
                <Image width="90px" src="/Framevision6.png" />
                <Header style={{fontSize:"28px"}}>Plant Status Detection</Header>
                <p style={{fontSize:"24px"}}>
                  Analyzes detected plants for their current status, suitability for harvesting, etc.
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <Divider hidden />
        <Divider hidden />

        <NextLevel />
      </>
    );
  }
}

AIVision = connect((store) => {
  return {
    data: store.data,
  };
})(AIVision);
